<template>
    <v-responsive
    aspect-ratio=".611"
    style="width: 100%; margin: auto; max-width: calc(100vw - 12px)"
  >
            <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="data.visitName || 'کارت ویزیت'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="data?.identifier || ''"
          :profile-avatar="data.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

  <component
    :is="components[data?.photo?.transition || 'scale']"
    mode="out-in"
    origin="center"
  >
    <div
      v-if="showWelcome && data?.photo?.hasWelcome"
      key="loading"
      class="col-md-11 mx-auto elevation-3 d-flex"
      style="min-height: 80vh"
    >
      <div v-if="data?.photo?.welcome === ''" class="col m-auto">
        <atom-spinner
          :animation-duration="1000"
          :size="80"
          class="mx-auto justify-content-center"
          color="#ff1d5e"
        />
      </div>
      <div v-if="data?.photo?.welcome !== ''" class="m-auto">
        <img
          :src="data.photo.welcome"
          alt=""
          class="bg-white rounded-circle mx-auto my-auto"
          width="100"
        />
      </div>
    </div>

    <div
      v-else-if="locationPage && data?.coordinates"
      key="location"
      class="col-md-12 elevation-3"
    >
      <v-card-title class="px-0 pt-0 justify-end">
        <v-btn
          class="mx-2 mr-auto text-left"
          color="white"
          @click="locationPage = false"
        >
          {{ localI18n.t("back") }}
          <v-icon class="ms-2" color="black">mdi-keyboard-backspace</v-icon>
        </v-btn>
      </v-card-title>

      <div>
        <p>
          <span class="fa fa-car ml-1 text-danger"></span>
          {{ localI18n.t("after_click_location") }}
        </p>

        <v-card
          v-if="locLoading"
          class="d-flex align-center justify-center"
          flat
          height="400"
          width="100%"
        >
          <atom-spinner
            :animation-duration="1000"
            :size="120"
            class="mx-auto justify-content-center"
            color="#ff1d5e"
          />
        </v-card>

        <mapir
          v-if="data?.apiKey && data?.coordinates"
          :apiKey="data.apiKey"
          :center="data.coordinates"
          :zoom="17"
          class="col-md-12"
          style="width: 100%; height: 400px"
          @click.self="openMap"
        >
          <mapNavigationControl position="top-right" />
          <mapMarker
            :coordinates.sync="data.coordinates"
            color="red"
            kind="marker"
            readonly
          >
            <template v-slot:marker>
              <v-icon>mdi-map-marker</v-icon>
            </template>
          </mapMarker>
        </mapir>
      </div>

      <div class="col-md-12 flex py-2 my-3">
        <p>
          <span><v-icon color="red">mdi-map-marker</v-icon></span
          >{{ data?.address }}
        </p>
      </div>
    </div>

    <div
      v-else
      key="theme"
      v-touch="{ left: () => swipe('Left'), right: () => swipe('Right') }"
      :class="{ flipped: flipped }"
      class="flip-card rounded-lg"
      :dir="currentTextDirection"
    >
      <div class="flip-card-inner rounded-lg">
        <v-card
          :style="{ background: data?.pallete?.headColor }"
          class="flip-card-front rounded-lg overflow-hidden"
          flat
        >
          <v-responsive
            :aspect-ratio="16 / 9"
            :style="{
              background: data?.photo?.headBackground
                ? `url('${data?.photo?.headBackground}')`
                : data?.pallete?.bodyColor,
            }"
            class="overflow-visible rounded-t-lg front-responsive"
          >
            <div
              v-if="data?.photo?.profile"
              :class="{ 'active-float': activeFloating }"
              class="white rounded-circle front-avatar"
            >
              <div
                v-if="data?.photo?.profile"
                :style="{ backgroundImage: `url(${data.photo.profile})` }"
                class="bg-filter"
              />
              <img
                :src="data.photo.profile"
                alt=""
                v-if="data?.photo?.profile"
              />
            </div>
          </v-responsive>

          <div
            :class="{ active: activeFloating }"
            :style="{ background: data.pallete.bodyColor }"
            class="floating-social social-front"
          >
            <v-btn
              :color="data.pallete.textColor"
              icon
              @click="activeFloating = !activeFloating"
            >
              <v-scale-transition mode="out-in" origin="middle">
                <v-icon v-if="!activeFloating" key="share-variant"
                  >mdi-share-variant</v-icon
                >
                <v-icon v-else key="close">mdi-close</v-icon>
              </v-scale-transition>
            </v-btn>

            <div class="floating-content" v-if="computeFields?.length > 0">
              <v-btn
                v-for="item in computeFields"
                :style="{ background: data?.pallete?.headColor }"
                class="ma-2"
                fab
                @click="goToUrl(item.url, item.pattern)"
              >
                <img
                  v-if="item?.img"
                  :src="item.img"
                  alt=""
                  class="img-fluid"
                  style="max-width: calc(100% - 12px)"
                  :height="item.svg.toLowerCase()==='svgbasalam'? '22px': isBigSvg(item.svg) ? '29px' : '32px'"
                  :width="item.svg.toLowerCase()==='svgbasalam'? '22px':isBigSvg(item.svg) ? '29px' : '32px'"
                />
              </v-btn>
            </div>
          </div>

          <div
            :style="{ color: data?.pallete?.textColor }"
            class="card-front-name"
          >
            <v-spacer />
            <v-card-title
            :style="{color:data.pallete.textColor}"
              class="font-size-h3 font-weight-bold text-center justify-center text-break"
              v-text="data?.organizationName"
            />
            <v-card-subtitle
            :style="{color:data.pallete.textColor}"
              class="mt-n1 font-size-h6 text-break"
              v-text="data?.subOrgan"
            />
            <v-spacer />

            <v-card-actions class="card-front-action">
              <v-btn
                :color="data?.pallete?.textColor"
                class="mx-2 btn-action"
                icon
                @click="flipped = !flipped"
              >
                <v-icon size="29">mdi-account</v-icon>
              </v-btn>
              <!-- Language Switcher -->
              <languageswitcherpopup
                v-if="availableLangs?.length > 1 && !flipped"
                v-model="showLangDialog"
                @source-changed="changeLanguage"
                :currentLang="currentLang"
                :headColor="data.pallete.headColor"
                :textColor="data.pallete.textColor"
                :expand="true"
              />

              <v-btn
                v-if="data?.companyNumber"
                :color="data.pallete.textColor"
                :href="`tel:${data.companyNumber}`"
                class="mx-2"
                icon
              >
                <v-icon size="29">mdi-phone</v-icon>
              </v-btn>

              <v-btn
                v-if="data?.coordinates"
                :color="data?.pallete?.textColor"
                class="mx-2"
                icon
                @click="locationPage = true"
              >
                <v-icon size="29">mdi-map-marker</v-icon>
              </v-btn>

              <v-tooltip top v-if="data?.customerClub && (data.customerClub.configs?.isActive || data.customerClub.title?.trim() || data.customerClub.description?.trim())">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="data?.pallete?.textColor"
                    class="mx-2"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon size="29">mdi-card-account-phone-outline</v-icon>
                  </v-btn>
                </template>

                <span>{{ localI18n.t("customer_club") }}</span>
              </v-tooltip>

              <v-btn
                v-if="
                  (data?.phoneNumber &&
                    data?.phoneNumber?.length > 0 &&
                    data?.phoneNumber?.[0]?.number) ||
                  data?.companyNumber
                "
                :color="data?.pallete?.textColor"
                :loading="vcfLoading"
                class="mx-2"
                icon
                @click="getVcf"
              >
                <v-icon size="29">mdi-plus</v-icon>
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>

        <v-card
          :dark="getDarkTheme"
          :style="{ background: data.pallete.bodyColor }"
          class="flip-card-back rounded-lg overflow-hidden"
          flat
        >
          <div
            :class="{ active: activeFloating }"
            class="floating-social social-back"
          >
            <v-btn
              :color="data.pallete.textColor"
              icon
              @click="activeFloating = !activeFloating"
            >
              <v-scale-transition mode="out-in" origin="middle">
                <v-icon v-if="!activeFloating" key="share-variant"
                  >mdi-share-variant</v-icon
                >
                <v-icon v-else key="close">mdi-close</v-icon>
              </v-scale-transition>
            </v-btn>

            <div class="floating-content" v-if="computeFields?.length > 0">
              <v-btn
                v-for="item in computeFields"
                :style="{ background: data?.pallete?.headColor }"
                class="ma-2"
                fab
                @click="goToUrl(item.url, item.pattern)"
              >
                <img
                  v-if="item?.img"
                  :src="item.img"
                  alt=""
                  class="img-fluid"
                  style="max-width: calc(100% - 12px)"
                  :height="item.svg.toLowerCase()==='svgbasalam'? '22px': isBigSvg(item.svg) ? '29px' : '32px'"
                  :width="item.svg.toLowerCase()==='svgbasalam'? '22px':isBigSvg(item.svg) ? '29px' : '32px'"
                />
              </v-btn>
            </div>
          </div>

          <v-card-text class="card-back-content custom-scrollbar">
            <div
              class="pt-4"
              :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
            >
              <drag-list v-model="draggingKeys">
                <template v-slot:default="{ item }">
                  <template v-if="item === 'userName'">
                    <p
                      v-if="data?.userName"
                      class="my-2"
                      :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                      :dir="getTextDirectionFromContent(data.userName)"
                      :style="{
                        textAlign: getTextAlignFromContent(data.userName),
                        color:data.pallete.textColor

                      }"
                    >
                      <v-icon>mdi-account-outline</v-icon>
                      : {{ data?.userName }}
                    </p>
                  </template>

                  <template v-else-if="item === 'workField'">
                    <p
                      v-if="data?.workField"
                      class="my-2"
                      :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                      :dir="getTextDirectionFromContent(data.workField)"
                      :style="{
                        textAlign: getTextAlignFromContent(data.workField),
                        color:data.pallete.textColor
                      }"
                    >
                      <v-icon>mdi-briefcase-account</v-icon>
                      : {{ data.workField }}
                    </p>
                  </template>

                  <template v-if="item === 'aboutUs'">
                    <div
                      v-if="data?.aboutUs"
                      class="my-2"
                      :dir="getTextDirectionFromContent(data.aboutUs)"
                      :style="{
                        textAlign: getTextAlignFromContent(data.aboutUs),
                        color:data.pallete.textColor
                      }"
                    >
                      <span><v-icon :style="{color:data.pallete.textColor}">mdi-comment-account-outline</v-icon></span>
                      :
                      <span class="font-weight-bolder"  :style="{color:data.pallete.textColor}">{{
                        localI18n.t("about_us")
                      }}</span>
                      <div class="col-md-12 mb-2">
                        <pre
                          class="my-0"
                          :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                          v-html="trancateTxts"
                          :dir="getTextDirectionFromContent(data.aboutUs)"
                          :style="{
                            textAlign: getTextAlignFromContent(data.aboutUs),
                            color:data.pallete.textColor

                          }"
                        />
                        <v-btn
                          v-if="
                            data?.aboutUs?.length > 200 ||
                            data?.aboutUs?.split('<div>')?.length > 3
                          "
                          class="ms-n4"
                          color="primary"
                          text
                          @click="isTruncate = !isTruncate"
                        >
                          {{
                            isTruncate
                              ? localI18n.t("view_more")
                              : localI18n.t("view_less")
                          }}
                        </v-btn>
                      </div>
                    </div>
                  </template>
                <!-- pdfSection -->
                <template v-if="item === 'pdf'">
                  <div v-if="data?.pdf && data?.pdf?.length > 0" class="box">
                      <pdf-preview-display
                        :pdf-data="data.pdf"
                        :layout-mode="layoutPreference"
                        :pdf-selector="data.pdfSelector"
                        :current-lang="currentLang"
                        :lang="currentLang"                     

                      />
                    </div>
                </template>
                <!--consultation-->
                <template v-if="item==='consultation'">
                  <consultation-new-show class="box pa-0 ma-0"
                    :style="{
                      background: data.consultationNew?.sectionColor?.backGround,
                      color: data.consultationNew?.sectionColor?.text,
                    }"
                    :color="data.consultationNew?.sectionColor?.text"
                    v-model="data.consultationNew"
                    :current-lang="currentLang"
                    :lang="currentLang"                     

                  />
                </template>
                <!--feedback-->
                <template v-if="item==='FeedBack'" >
                  <b-feedback-view style="width: 97% !important;"
                      v-if="data.FeedBack && data.FeedBack.items.length > 0"
                      v-model="data.FeedBack"
                    :current-lang="currentLang"
                    :lang="currentLang"                     

                  />
                </template>
                  <template
                    v-if="item === 'video_single' && !!data?.video_single"
                  >
                    <v-card
                      v-for="(item, i) in data.video_single.videos"
                      :key="i"
                      class="transparent"
                      flat
                      style="max-width: 100%"
                    >
                      <v-card-title
                        :class="{ 'blue--text clickable': item.link }"
                        :href="fixLink(item.link)"
                        :tag="item.link ? 'a' : 'div'"
                        class="pa-2 text-break"
                        target="_blank"
                        v-text="item.title"
                      />
                    <video
                      v-if="isDirectVideo(item.url)"
                      :src="item.url"
                      controls
                      style="max-width: 100%; height: auto; width: 100%;"
                    ></video>
                    <iframe
                      v-else
                      :src="item.url"
                      style="max-width: 100%; height: auto; width: 100%;"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                      <pre v-html="item.description" :style="{color: data?.pallete?.textColor}"/>
                    </v-card>
                  </template>

                  <div
                    v-else-if="
                      item === 'video_gallery' &&
                      !!data.video_gallery?.[0]?.images?.length > 0
                    "
                    class="d-flex flex-column"
                  >
                    <div
                      v-for="(src, i) in data.video_gallery[0].images"
                      :key="i"
                    >
                      <v-card-title
                        :href="!!src.link ? src.link : null"
                        :tag="!!src.link ? 'a' : 'div'"
                        class="pa-2"
                        target="_blank"
                        v-html="src.title"
                        :dir="getTextDirectionFromContent(src.title)"
                        :style="{
                          textAlign: getTextAlignFromContent(src.title),
                        }"
                      />
                  <video
                    v-if="isDirectVideo(src.url || src.file_link)"
                    :src="src.url || src.file_link"
                    controls
                    style="max-width: 100%; height: auto; width: 100%;"
                  ></video>
                  <iframe
                    v-else
                    :src="src.url || src.file_link"
                    style="max-width: 100%; height: auto; width: 100%;"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                      <v-card-text
                        v-show="!!src.description"
                        v-html="src.description"
                        :dir="getTextDirectionFromContent(src.description)"
                        :style="{
                          textAlign: getTextAlignFromContent(src.description),
                        }"
                      />
                    </div>
                  </div>

                  <template
                    v-else-if="item === 'photo' && data?.photo?.gallery"
                  >
                  <div style="max-width: calc(100% - 24px)" v-if="data?.photo?.gallery">
                    <image-slider
                      v-model="data.photo.gallery"
                      :orientation="resolvedOrientation"
                      :is-slider="resolvedIsSlider"
                    />                                                    
                  </div>
                  </template>

                  <template
                    v-else-if="item === 'extraFields' && data?.extraFields"
                  >
                    <extra-shown v-model="data.extraFields" :fontColor="data.pallete.textColor" :style="{color:data.pallete.textColor}"/>
                  </template>

                  <template 
                    v-else-if="item === 'phoneNumber' && data?.phoneNumber"
                  >
                    <div>
                      <p :style="{color:data.pallete.textColor}"
                        v-for="(p, i) in data.phoneNumber"
                        :key="i"
                        :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                      >
                        <v-icon color="red">mdi-phone-outline</v-icon>
                        :
                        <a :style="{color:data.pallete.textColor}"
                          :href="`tel:${p.number.replace(/[^\d]/g, '')}`"
                          class="link-tag text-left clickable mx-1"
                          target="_blank"
                          dir="ltr"
                        >
                          {{ p.number.replace(/[^\d\+]/g, "") }}
                        </a>
                        {{ p.text }} {{ p.number.replace(/[\d\^+]/g, "") }}
                      </p>
                    </div>
                  </template>

                  <template v-else-if="item === 'fax'">
                    <p :style="{color:data.pallete.textColor}"
                      v-if="data?.fax"
                      class="my-2"
                      :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    >
                      <v-icon>mdi-fax</v-icon>
                      : {{ data?.fax }}
                    </p>
                  </template>

                  <template v-else-if="item === 'location'">
                    <div :class="isCurrentLangRTL ? 'text-right' : 'text-left'">
                      <pre :style="{color: data?.pallete?.textColor}" v-if="data?.location" class="d-flex justify-start align-start my-2">
                          <v-icon :color="data?.pallete?.textColor">mdi-map-marker</v-icon>: <span :style="{color: data?.pallete?.textColor}" >{{ data?.location }}</span>
                    </pre
                      >
                    </div>
                  </template>

                  <template v-else-if="item === 'codePostal'">
                    <p :style="{color:data.pallete.textColor}"
                      v-if="data?.codePostal"
                      class="my-2"
                      :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    >
                      <v-icon>mdi-post</v-icon>
                      : {{ data?.codePostal }}
                    </p>
                  </template>

                  <template v-else-if="item === 'email' && data?.email">
                    <a :href="`mailto:${data.email}`" target="_blank" :style="{color:data.pallete.textColor}">
                      <p :style="{color:data.pallete.textColor}"
                        v-if="data?.email"
                        class="my-2 clickable link-tag"
                        :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                      >
                        <span :style="{color:data.pallete.textColor}"
                          ><v-icon color="red">mdi-email-outline</v-icon></span
                        >
                        : {{ data?.email }}
                      </p>
                    </a>
                  </template>

                  <template v-else-if="item === 'website'">
                    <p :style="{color:data.pallete.textColor}"
                      v-if="data?.website"
                      class="my-3 clickable link-tag"
                      :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                      @click="goToUrl(data.website)"
                    >
                      <span><v-icon color="blue">mdi-earth</v-icon></span> :
                      {{ data.website }}
                    </p>
                  </template>
                  <template
                    v-else-if="
                      item.startsWith('audio_') &&
                      data?.audiosGallery?.audios?.length > 0
                    "
                  >
                    <v-col cols="12">
                      <v-card
                        v-if="data?.audiosGallery?.audios"
                        width="300"
                        height="auto"
                        :style="{ background: getAudioById(item)?.background }"
                        class="pa-0 my-2 d-flex align-items-center flex-column"
                        :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                      >
                        <v-card-title
                          :style="{ color: getAudioById(item)?.color }"
                          v-if="getAudioById(item)?.ti?.length > 0"
                          >{{ getAudioById(item)?.ti }}</v-card-title
                        >
                        <v-card-subtitle
                          :style="{ color: getAudioById(item)?.color }"
                          class="pa-0"
                          v-if="getAudioById(item)?.desc?.length > 0"
                          >{{ getAudioById(item)?.desc }}</v-card-subtitle
                        >
                        <component
                          :is="data?.audiosGallery?.audioType"
                          :file="getAudioById(item)?.full_path"
                          :link="false"
                          :inf="{
                            ti: getAudioById(item)?.ti,
                            link: getAudioById(item)?.link,
                            title: getAudioById(item)?.title,
                            desc: getAudioById(item)?.desc,
                          }"
                          :image="getAudioById(item)?.image"
                          :title="
                            getAudioById(item)?.title?.length > 0
                              ? getAudioById(item)?.title
                              : $t('audio_file')
                          "
                          width="100%"
                          :height="
                            data?.audiosGallery?.audioType == 'newPlayer'
                              ? 280
                              : 150
                          "
                          :flat="true"
                          :audioSound="false"
                          :color="getAudioById(item)?.color"
                          background="transparent"
                        :auto-play="item.autoPlay"

                        />
                      </v-card>
                    </v-col>
                  </template>
                </template>
              </drag-list>
            </div>
          </v-card-text>

          <v-card-actions class="card-back-action">
            <v-btn
              :color="data.pallete.textColor"
              class="mx-2 btn-action"
              icon
              @click="flipped = !flipped"
            >
              <v-icon size="29" :style="{color:data?.pallete.textColor}">mdi-backup-restore</v-icon>
            </v-btn>
            <!-- Language Switcher -->
            <languageswitcherpopup
              v-if="availableLangs?.length > 1 && flipped"
              v-model="showLangDialog"
              @source-changed="changeLanguage"
              :currentLang="currentLang"
              :headColor="data.pallete.headColor"
              :textColor="data.pallete.textColor"
              :expand="true"
            />

            <v-btn
              v-if="data?.companyNumber"
              :color="data?.pallete?.textColor"
              :href="`tel:${data.companyNumber}`"
              class="mx-2"
              icon
            >
              <v-icon size="29">mdi-phone</v-icon>
            </v-btn>

            <v-btn
              v-if="data?.coordinates"
              :color="data?.pallete?.textColor"
              class="mx-2"
              icon
              @click="locationPage = true"
            >
              <v-icon size="29">mdi-map-marker</v-icon>
            </v-btn>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="data?.pallete?.textColor"
                  class="mx-2"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="29">mdi-card-account-phone-outline</v-icon>
                </v-btn>
              </template>

              <span>{{ localI18n.t("customer_club") }}</span>
            </v-tooltip>

            <v-btn
              v-if="
                (data?.phoneNumber &&
                  data?.phoneNumber?.length > 0 &&
                  data?.phoneNumber?.[0]?.number) ||
                data?.companyNumber
              "
              :color="data?.pallete?.textColor"
              :loading="vcfLoading"
              class="mx-2"
              icon
              @click="getVcf"
            >
              <v-icon size="29">mdi-plus</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </component>
  </v-responsive>
</template>

<script>
import PdfPreviewDisplay from "@/view/components/Gallery/PdfPreviewDisplayCell_multilang";
import ConsultationNewShow from "../../../../components/consultationNew/consultationNewShowCell_multilang.vue";
import BFeedbackView from "../../../businessPage/components/view/bFeedbackView_mulilang.vue";
import {
  textDirectionMixin,
  detectLanguage,
  getTextAlign,
} from "@/utilities/textDirection";
import axios from "axios";
import localI18n from "@/i18n_local_cardvisit";
import { mapGetters, mapActions } from "vuex";
import { Bus, debounce } from "@/main";
import {
  mapGeolocateControl,
  mapir,
  mapMarker,
  mapNavigationControl,
} from "mapir-vue";
import { AtomSpinner } from "epic-spinners";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib";
import FloatingBtn from "../../../otherQrTypes/photoGallery/components/floatingBtn";
import GallerySlider from "../../../businessPage/components/view/gallerySlider";
import ImageSlider from "../../../../components/Gallery/imageSlider";
import DragList from "../../dragList";
import ExtraShown from "../../../../components/Product/extraShown.vue";
import { setDragging } from "@/utilities/DraggingKeysOrder";
import AudioPlayerCard from "../../../../components/UploadCenter/voiceGallery/components/audio/audioPlayerCard.vue";
import newPlayer from "../../../../components/UploadCenter/voiceGallery/components/audio/newPlayer.vue";
import newPlayer2 from "../../../../components/UploadCenter/voiceGallery/components/audio/newPlayer2.vue";
import languageswitcherpopup from "../languageswitcherpopup.vue";
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";

export default {
  name: "visitThemeFlipped",
  mixins: [textDirectionMixin],
  components: {
    ExtraShown,
    DragList,
    ImageSlider,
    GallerySlider,
    FloatingBtn,
    mapGeolocateControl,
    mapir,
    mapMarker,
    mapNavigationControl,
    AtomSpinner,
    AudioPlayerCard,
    newPlayer,
    newPlayer2,
    languageswitcherpopup,
    BFeedbackView,
    ConsultationNewShow,
    PdfPreviewDisplay,
    UniversalQrModal,

  },

  props: {
    value: Object,
    orders: Array,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },

  data: () => ({
    localI18n,
    showQrDialog:false,
    showLangDialog: false,
    currentLang: "fa",
    langDataCache: {},
    activeFloating: false,
    flipped: false,
    isTruncate: true,
    vcfLoading: false,
    showWelcome: false,
    locationPage: false,
    locLoading: false,
    components: {
      scale: VScaleTransition,
      slideX: VSlideXTransition,
      slideY: VSlideYTransition,
      fade: VFadeTransition,
    },
  }),

  mounted() {
    setTimeout(() => {
      this.setKeys(this.data);
      this.$root.$on("visit-data-updated", (payload) => {
        if (payload.data.lang === this.currentLang) return;

        this.data = payload?.data?.data;
        // this.orders = payload.orders;
        // this.theme = payload.data.theme;
        this.$forceUpdate();
      });

      this.ensureDefaults();
      this.changeLanguage(this.sourceLanguage);
    }, 200);
    if (
      !this.data ||
      !this.data?.pallete ||
      Object.keys(this.data?.pallete)?.length <= 0 ||
      ["qr.create","auto.create","qr.cardVisit"].includes(this.$route.name)
    ) {
      this.valueComputed.pallete = {
        headColor: "linear-gradient(to bottom, #FF00F6FF, #11001AFF)",
        bodyColor: "linear-gradient(to top left, #A238C1FF, #F2D2FFFF)",
        textColor: "#ffffff",
        borderColor: "#393939",
      };
    }

    if (
      !this.data?.photo ||
      !this.data?.photo?.headBackground ||
      ["qr.create","auto.create","qr.cardVisit"].includes(this.$route.name)
    )
      this.data.photo.headBackground =
        "/media/defaults/visitFlippedDefault.webp";

    if (!!this.orders.length) this.fixOrders(this.value);
    else this.setKeys(this.value);

    Bus.$on("showMe", (value) => {
      if (this.value?.photo.hasWelcome) {
        this.showWelcome = true;
        this.locationPage = false;
        setTimeout(() => {
          this.locationPage = false;
          this.showWelcome = false;
        }, 3000);
      }
    });
    this.$root.$on("visit-data-updated", (payload) => {
      if (payload?.data?.lang === this.currentLang) return;

      this.data = payload.data?.data;
      // this.orders = payload.orders;
      this.theme = payload.data?.theme;
      this.$forceUpdate();
    });
    this.ensureDefaults();
    this.changeLanguage(this.defaultLang);
    this.$forceUpdate();
  },
  beforeDestroy() {
    this.$root.$off("fetchDragList");
    this.$root.$off("card-lang-reset");
    this.$root.$off("mobile-viewer-lang-change");
  },

  computed: {
    ...mapGetters("localstorage", [
      "mainDatalang",
      "createQrID",
      "alllangs",
      "defaultLang",
      "currentlanguage",
    ]),
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
    resolvedIsSlider() {
    var photoPicSelector =
      this.data &&
      this.data.photo &&
      this.data.photo.PicSelector;

    var mainPicSelector =
      this.data &&
      this.data.PicSelector;

    if (
      photoPicSelector &&
      photoPicSelector.slider != null
    ) {
      return photoPicSelector.slider;
    }

    if (
      mainPicSelector &&
      mainPicSelector.slider != null
    ) {
      return mainPicSelector.slider;
    }

    return true;
  },

  resolvedOrientation() {
    var photoPicSelector =
      this.data &&
      this.data.photo &&
      this.data.photo.PicSelector;

    var mainPicSelector =
      this.data &&
      this.data.PicSelector;

    if (
      photoPicSelector &&
      photoPicSelector.orientation != null
    ) {
      return photoPicSelector.orientation;
    }

    if (
      mainPicSelector &&
      mainPicSelector.orientation != null
    ) {
      return mainPicSelector.orientation;
    }

    return "horizontal";
  },
    layoutPreference() {
      if (this.value.pdfSelector && this.value.pdfSelector.slider) {
        return "slider";
      }
      if (this.value.pdfSelector && this.value.pdfSelector.layout) {
        return this.value.pdfSelector.layout;
      }

      return "list";
    },
    isCurrentLangRTL() {
      const lang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return this.isRTL(lang);
    },
    currentTextDirection() {
      const lang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return this.getTextDirection(lang);
    },
    sourceLanguage() {
      return this.defaultLang || "fa";
    },
    data: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    availableLangs() {
      const defaultLang = this.defaultLang || "fa";
      const extraLangs = Array.isArray(this.alllangs) ? this.alllangs : [];
      return [defaultLang, ...extraLangs]
        .filter((lang) => lang && typeof lang === "string")
        .filter((lang, idx, arr) => arr.indexOf(lang) === idx);
    },
    canSaveContact() {
      return (
        (this.data?.phoneNumber?.length > 0 &&
          this.data?.phoneNumber?.[0]?.number) ||
        this.data?.companyNumber
      );
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    trancateTxts() {
      let about = this.data?.aboutUs || "";
      const more = about?.split("<div>")?.length > 3;

      const text = () => {
        let variable = about?.split("<div>");
        let generatedText = "";
        for (let a = 0; a <= 3; a++) {
          generatedText += "<div>" + variable[a];
        }
        return generatedText;
      };

      about =
        (about.length > 200 || more) && this.isTruncate
          ? (more ? text() : about.slice(0, 100)) + "&hellip;"
          : about;

      return about
        .replace(
          /style="width:604px;height:270px" /gms,
          'style="width:100%;height:auto"',
        )
        .replace(/style="display: block;padding-top: 57%"/gms, "");
      // return about.replace(/<div class="h_iframe-.*<iframe/gms, '<iframe ').replace(/ style="width:604px;height:270px" /gms, '');
    },
    thirdOne() {
      let top = {};

      Object.entries(this.data?.socialMedia)
        .slice(0, 3)
        .forEach(([x, y]) => {
          top[x] = y[0];
        });

      return top;
    },
    computeFields() {
      let extra = [];

      Object.entries(this.data?.socialMedia)?.forEach(([x, y]) => {
        extra.push(...y);
      });
      Object.values(this.thirdOne)?.forEach((x) => {
        extra = extra?.filter((item) => item !== x);
      });
      return extra;
    },
    getHeaderImg() {
      if (!this.expand) {
        return (
          this.data?.photo?.profile ?? this.data?.photo?.headBackground ?? false
        );
      }

      return this.data?.photo?.headBackground ?? false;
    },
    hasExtra() {
      let arr = this.data?.extraFields?.filter(
        (item) => !!item?.name || !!item?.icon || !!item?.value,
      );
      return arr && arr?.length > 0;
    },
    getDarkTheme() {
      let rgx = new RegExp(/#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})/, "gm");
      if (this.value?.pallete?.bodyColor) {
        let hex = this.data?.pallete?.bodyColor?.match(rgx);
        let count = 0;
        for (let i = 0; i < hex.length; i++) {
          count += this.brightness(hex[i]);
        }
        count = count / hex.length;
        this.data.pallete.isDarkBody = count <= 160;
        return count <= 160;
      }
      return false;
    },
    draggingKeys: {
      get() {
        return this.orders;
      },
      set(val) {
        this.$emit("update:orders", val);
      },
    },
  },
  created() {
    // this.$root.$on("mobile-viewer-lang-change", (lang) => {
    //   this.changeLanguage(lang);
    //   this.$forceUpdate();
    // });

    this.$root.$on("lang-data-loaded", ({ lang, data }) => {
      if (this.currentLang === lang) {
        this.applyLangData(lang, data);
      }
    });
    this.$root.$on("fetchDragList", this.setKeys);
  },

  watch: {
    currentlanguage: {
      handler(lang) {
        this.changeLanguage(lang);
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },

    "data.langs": {
      handler() {
        this.$forceUpdate();
      },
      deep: true,
    },
    "$i18n.locale"(newLocale) {
      const hasLocalLang = this.data?.langs?.other_langs?.some(
        (l) => l.lang === this.currentLang,
      );
      if (!hasLocalLang) {
        this.changeLanguage(newLocale);
      }
    },

    locationPage(val) {
      if (val) {
        this.locLoading = true;
        this.getlatLng();
      }
    },
    value: {
      deep: true,

      handler(val) {
        debounce(() => {
          this.setKeys(val);
        }, 1300);
      },
    },
  },

  methods: {
    ...mapActions("localstorage", [
      "setDraggingKeysOrder",
      "setLangList",
      "setDefaultLang",
      "setCurrentLanguage",
    ]),
     isDirectVideo(url) {
    if (!url) return false;
    return /\.(mp4|webm|ogg)$/i.test(url.trim());
  },
    isBigSvg(svg) {
    const list = [
      'svgdigikala',
      'svgbasalam',
      'svgsnappshop',
      'svgtechnolife',
      'svgtorob',
      'svgemalls',
      'svgrubika',
      'svgwhatsapp',
      'svgbale',
      'svgeitaa',
      'svgsoroush',
      'svgtelegram',
      'svgviber',
      'svgwechat',
      'svgsheypour',
      'svgdivar',
      'svgaparat',
      'svggap'
    ];
        return list.includes((svg || '').toLowerCase());
  },
    getTextDirectionFromContent(text) {
      if (!text || typeof text !== "string") return this.currentTextDirection;
      const fallbackLang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return detectLanguage(text, fallbackLang);
    },
    getTextAlignFromContent(text) {
      if (!text || typeof text !== "string")
        return this.isCurrentLangRTL ? "right" : "left";
      const fallbackLang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return getTextAlign(text, fallbackLang);
    },
    ensureDefaults() {
      if (!this.data) return;
      // pallete
      if (!this.data?.pallete) {
        this.data.pallete = {
          headColor: "linear-gradient(to top, #AA7630FF, #EBCB63FF)",
          bodyColor: "linear-gradient(to top right, #AA7630FF, #EBCB63FF)",
          textColor: "#ffffff",
          borderColor: "#393939",
        };
      }
      // photo
      if (!this.data?.photo) this.data.photo = {};
      // if (!this.data?.photo?.headBackground) {
      //   this.data.photo.headBackground =
      //     "/media/defaults/visitFirstDefault.webp";
      // }
      if (!this.data?.photo?.transition) {
        this.data.photo.transition = "scale";
      }
      // langs
      if (!this.data?.langs) {
        this.data.langs = { source_lang: "fa", other_langs: [] };
      }
    },

    internalLangChange(lang) {
      // if (lang === this.currentLang) {
      //   return;
      // }
      this.$root.isTranslating = true;
      this.changeLanguage(lang);
    },
    syncInitialLang() {
      // if (this.data.langs?.other_langs?.length > 0) {
      //   const firstLang = this.data.langs.other_langs[0].lang;
      //   this.changeLanguage(firstLang);
      // } else {
      this.changeLanguage(
        this.sourceLanguage || this.defaultLang || this.$i18n.locale,
      );
      // }
    },

    changeLanguage(newLang) {
      if (!newLang || newLang === this.currentLang) {
        this.$root.isTranslating = false;
        return;
      }

      if (!newLang || newLang === this.currentLang) return;
      const selectlang =
        typeof newLang === "string"
          ? newLang
          : (Array.isArray(newLang) ? newLang[0] : newLang)?.lang || "fa";
      if (!selectlang) {
        this.$root.isTranslating = false;
        return;
      }
      this.$root.isTranslating = true;

      if (selectlang === this.defaultLang) {
        this.data = this.mainDatalang?.data?.data;
        this.localI18n.locale = selectlang;
        this.$root.isTranslating = false;
      } else {
        this.$root.isTranslating = true;
        this.$api
          .get(`/langData?id=${this.createQrID}&lang=${selectlang}`)
          .then((res) => {
            // const data = res?.data?.data;
            // const { data, theme, orders } = QrDataFormatter.unpack(res.data);
            // this.data = res.data.data;
            // this.theme = res.data.theme;
            // this.orders = orders;

            //for data commeit
            // if (this.data === null || this.data === undefined) {
            //   this.changeLanguage(this.defaultLang || this.sourceLanguage);
            //   this.$toast.warning(localI18n.t("errors.service_unavailable"));
            //   return;
            // }
            this.$emit("input", res.data.data.data);

            this.$root.$emit("mobile-viewer-updated", {
              orders: res.data.data.orders,
              theme: res.data.data.theme,
              data: res.data.data.data,
              lang: newLang,
            });
            //   this.$root.$emit("mobile-viewer-lang-change", selectlang);
            this.setCurrentLanguage(selectlang);

            //new change
            this.data = res?.data?.data?.data;
            // this.theme = res.data.data.theme;
            // this.orders = res.data.data.orders;
            //  this.langDataCache[newLang] = data;

            this.applyLangData(newLang, this.data);
          })
          .catch(() => {
            this.$root.isTranslating = false;
            //   this.changeLanguage(this.sourceLanguage);
          })
          .finally(() => {
            this.$root.isTranslating = false;
            this.showLangDialog = false;
          });
      }
    },

    applyLangData(lang, data) {
      this.data = { ...data };
      this.ensureDefaults();
      this.currentLang = lang;
      this.localI18n.locale = lang;

      // this.cacheCurrentData();
    },

    // cacheCurrentData() {
    //   this.langDataCache[this.currentLang] = { ...this.data };
    // },
    show() {
      this.showconncet = !this.showconncet;
      Bus.$emit("showconnect", this.showconncet);
    },

    openMap() {
      let agent = window.navigator.userAgent;
      let type = "https://www.google.com/maps/@";

      if (agent.toLowerCase().search("android") > 0) {
        type = "geo:";
      } else if (
        agent.search("iPad") > 0 ||
        agent.search("iPhone") > 0 ||
        agent.search("iPod") > 0
      ) {
        type = "maps:";
      }

      window.open(
        `${type}${this.data?.coordinates?.[1]},${this.data?.coordinates?.[0]}?q=${this.data?.coordinates?.[1]},${this.data.coordinates[0]}`,
        "_blank",
      );
    },
    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },
    getlatLng() {
      axios({
        method: "GET",
        baseURL: "https://map.ir/reverse",
        params: {
          lat: this.data?.coordinates?.[1],
          lon: this.data?.coordinates?.[0],
        },
        timeout: 15000,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.data.address = response?.data?.address;
        })
        .finally(() => (this.locLoading = false));
    },
    getVcf() {
      this.vcfLoading = true;

      const info = {
        fax: undefined,
        email: undefined,
        visitName: undefined,
        organizationName: undefined,
        subOrgan: undefined,
        userName: undefined,
        workField: undefined,
        phoneNumber: undefined,
        companyNumber: undefined,
        location: undefined,
        city: undefined,
        photo: undefined,
        codePostal: undefined,
        province: undefined,
        country: undefined,
        website: undefined,
        socialMedia: undefined,
        aboutUs: undefined,
        address: undefined,
      };

      Object.keys(info).forEach((x) => {
        info[x] = this.value[x];
      });
      axios
        .post(process.env.VUE_APP_VCF, info)
        .then((x) => {
          var a = document.createElement("a"); //Create <a>
          a.href = "data:text/vcard;charset=utf-8;base64," + x.data; //Image Base64 Goes here
          a.download = `${info.userName}.vcf`; //File name Here
          a.click(); //Downloaded file
        })
        .finally(() => (this.vcfLoading = false));
    },
    extraIsLink(item) {
      return !!item.link && !!item.link.length;
    },
    fixLink(link) {
      return !!link?.startsWith("http") ? link : "https://" + link;
    },
    swipe(dir) {
      if (dir === "Right" && !this.flipped) {
        this.flipped = true;
      } else if (dir === "Left" && this.flipped) {
        this.flipped = false;
      }
    },
    brightness(input) {
      const color = "" + input,
        isHEX = color.indexOf("#") == 0;
      if (isHEX) {
        const m = color
          .substr(1)
          .match(color.length == 7 ? /(\S{2})/g : /(\S{1})/g);
        if (m)
          var r = parseInt(m[0], 16),
            g = parseInt(m[1], 16),
            b = parseInt(m[2], 16);
      }
      if (typeof r != "undefined") return (r * 299 + g * 587 + b * 114) / 1000;
    },
    fixOrders(val) {
      // Get the keys from the input object
      const keys = Object.keys(val);

      // Extract the names from the draggingKeys array
      const mapOrder = this.draggingKeys.map((item) => item.name);

      // Filter keys to include only those present in mapOrder
      const result = keys.filter((item) => mapOrder.includes(item));

      // Sort the filtered keys based on their order in mapOrder
      const sortedKeys = result.sort(
        (a, b) => mapOrder.indexOf(a) - mapOrder.indexOf(b),
      );

      // Update draggingKeys with the sorted keys
      this.draggingKeys = sortedKeys.map((item) => ({ name: item }));
    },
    setKeys(val = this.value) {
      // this.draggingKeys = setDragging(val, this.draggingKeys);
      let keys = setDragging(val, this.draggingKeys);

      if (val.audiosGallery?.audios && val.audiosGallery?.audios?.length >= 0) {
        const audioKeys = val.audiosGallery?.audios?.map((_, index) => ({
          name: `audio_${index}`,
        }));
        keys = [
          ...keys.filter((key) => !key.name.startsWith("audio_")),
          ...audioKeys,
        ];
      }

      this.draggingKeys = keys.filter((item) => item.name !== "audiosGallery");

      keys = keys.filter(
        (item) => item.name !== "langs" && item.name !== "language",
      );
    },
    getAudioById(itemId) {
      const index = parseInt(itemId.replace("audio_", ""));
      return this.data?.audiosGallery?.audios?.[index] || {};
    },
  },
};
</script>

<style lang="scss" scoped>
.flip-card {
  background-color: transparent;
  width: 100%;
  max-width: 100%;
  height: 80vh;
  max-height: 630px;
  perspective: 1000px;

  &.flipped {
    transform: none !important;

    .card-front-action {
      visibility: hidden;
    }

    .flip-card-inner {
      transform: rotateY(180deg);
    }

    .flip-card-front > * {
      visibility: hidden;
    }
  }

  .flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 100%;
    text-align: center;
    -webkit-transition: transform 0.6s;
    transition: transform 0.6s;
    -webkit-transform-style: preserve-3d !important;
    transform-style: preserve-3d !important;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  }

  .flip-card-front,
  .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden !important;
    backface-visibility: hidden !important;

    .floating-social {
      margin: 8px 8px 0;
      background: rgba(0, 0, 0, 0);
      text-align: right;
      padding: 4px;
      border-radius: 50% !important;
      height: 44px;
      width: 44px;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      z-index: 10;
      position: relative;

      .floating-content {
        display: none;
        width: 100%;
        margin-top: 16px;
        justify-content: space-evenly;
        flex-wrap: wrap;
        transform: translateY(-50%);
      }

      &.active {
        margin: 0;
        border-radius: 0 !important;
        position: relative;
        height: 100%;
        width: 100%;

        .floating-content {
          position: absolute;
          top: 20%;
          left: 0;
          display: flex;
          animation: floating-content-anm 0.3s both;
          animation-delay: 0.5s;
        }
      }
    }
  }

  .flip-card-front {
    .front-responsive {
      box-sizing: border-box;
      background-size: cover !important;
      background-repeat: no-repeat !important;
      background-position: top !important;
    }

    .front-avatar {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 50%);
      transition: transform 0.3s;
      width: 130px;
      height: 130px;
      border: 3px solid white;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;

      &.active-float {
        transform: translate(-50%, -10px);
      }

      .bg-filter {
        position: absolute;
        inset: -4px;
        background-size: cover;
        filter: blur(1.8px) brightness(1.3) opacity(0.8);
      }

      img {
        position: relative;
        z-index: 2;
        max-width: 100%;
        max-height: 100%;
      }
    }

    .card-front-name {
      bottom: 0;
      left: 0;
      display: flex;
      padding-top: 66.6667%;
      flex-direction: column;
      position: absolute;
      justify-content: flex-end;
      width: 100%;
      height: 100%;
    }

    .card-front-action {
      justify-content: center;

      .btn-action {
        animation: btn-action-anm 5s;
        animation-delay: 2s;
        animation-iteration-count: infinite;
      }
    }
  }

  .flip-card-back {
    transform: rotateY(180deg);
    height: 100%;

    .floating-social {
      z-index: auto !important;
    }

    .card-back-content {
      margin: 16px;
      padding: 16px;
      max-width: calc(100% - 32px);
      height: calc(100% - 132px);
      max-height: calc(100% - 132px);
      overflow-y: auto;
    }

    .card-back-action {
      justify-content: center;

      .btn-action {
        animation: back-btn-action-anm 5s;
        animation-delay: 2s;
        animation-iteration-count: infinite;
      }
    }
  }
}

@keyframes btn-action-anm {
  0% {
    transform: scale(1) translateY(0) rotate(0);
  }
  5% {
    transform: scale(1.3) translateY(-10px) rotate(15deg);
  }
  10% {
    transform: scale(1.4) translateY(-15px) rotate(-15deg);
  }
  14% {
    transform: scale(0.8) translateY(10px) rotateY(-180deg);
  }
  20% {
    transform: scale(1) translateY(0) rotate(0);
  }
}

@keyframes back-btn-action-anm {
  0% {
    transform: rotate(0);
  }
  5% {
    transform: rotate(15deg);
  }
  10% {
    transform: rotate(-25deg);
  }
  20% {
    transform: rotate(360deg);
  }
  30% {
    transform: rotate(0);
  }
  35% {
    transform: rotate(15deg);
  }
  40% {
    transform: rotate(0);
  }
}

@keyframes floating-content-anm {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
  color: inherit !important;
}

iframe {
  border: none;
  border-radius: 8px;
}

.link-tag,
.link-tag .v-icon {
  color: #0985d2;
  cursor: pointer;
}

.link-tag:hover,
.link-tag:hover .v-icon {
  color: #33a9f1;
}
.box{
  width: 97% !important;
}
// ::v-deep pre *, ::v-deep .v-card__text * {
//   color: inherit !important;
// }
.qr-floating-btn {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
